import React, { useContext } from 'react';
import { IndexContext } from '../../context';

const Demos = ({ indexDemo }) => {
  const { isLogged } = useContext(IndexContext);

  return (
    <section className="index-demos" id="index-demo">
      <picture>
        <source
          media="(min-width: 769px)"
          srcSet={indexDemo.demoCloudBg}
          type="image/png"
          style={{ height: 'auto' }}
        />
        <source media="(max-width: 768px)" srcSet="data:image/gif;base64,01" type="image/gif" />
        <img
          className="index-demos-bg lazyloaded"
          alt={indexDemo.cloudAlt}
          src={indexDemo.demoCloudBg}
          style={{ height: 'auto' }}
          loading="lazy"
        />
      </picture>
      <h2 className="index-heading-blue index-demo-heading" children={indexDemo.demoTitle} />
      {!isLogged && (
        <span>
          <p className="index-demo-text-big">{indexDemo.demoTextBig}</p>
          <a className="btn-blue index-try-demo-btn" href="/authorization/registration/">
            {indexDemo.buttText}
          </a>
          <p className="index-demo-text-small">{indexDemo.demoTextSmall}</p>
        </span>
      )}

      <figure className="index-demos-macbook">
        <picture>
          <source media="(min-width: 1161px)" srcSet={indexDemo.demosMacbookImg} type="image/png" />
          <source media="(max-width: 1160px)" srcSet="data:image/gif;base64,01" type="image/gif" />
          <img
            data-src={indexDemo.demosMacbookImg}
            className="index-demos-macbook-bg lazyloaded"
            alt={indexDemo.macbookAlt}
            src={indexDemo.demosMacbookImg}
            loading="lazy"
          />
        </picture>
        <picture>
          <source media="(min-width: 1161px)" srcSet={indexDemo.demoImg} type="image/png" />
          <source media="(max-width: 1160px)" srcSet="data:image/gif;base64,01" type="image/gif" />
          <img
            data-src={indexDemo.demoImg}
            className="index-macbook-screen lazyloaded"
            alt={indexDemo.macbookTitle}
            title={indexDemo.macbookTitle}
            src={indexDemo.demoImg}
            loading="lazy"
          />
        </picture>
        <div className="index-demos-phone">
          <picture>
            <source media="(min-width: 1161px)" srcSet={indexDemo.demoPhone} type="image/png" />
            <source
              media="(max-width: 1160px)"
              srcSet="data:image/gif;base64,01"
              type="image/gif"
            />
            <img
              data-src={indexDemo.demoPhone}
              alt={indexDemo.phoneTitle}
              title={indexDemo.phoneTitle}
              className="index-demos-phone-bg lazyloaded"
              src={indexDemo.demoPhone}
            />
          </picture>
          <picture>
            <source media="(min-width: 1161px)" srcSet={indexDemo.appScreen} type="image/png" />
            <source
              media="(max-width: 1160px)"
              srcSet="data:image/gif;base64,01"
              type="image/gif"
            />
            <img
              data-src={indexDemo.appScreen}
              alt={indexDemo.demoPhoneTitle}
              title={indexDemo.demoPhoneTitle}
              className="index-demos-phone-inner lazyloaded"
              src={indexDemo.appScreen}
            />
          </picture>
        </div>
      </figure>
    </section>
  );
};

export default Demos;
